const locale = require('./proposalSummaries.i18n.json');

/*@ngInject*/
const ProposalSummariesController = function ($scope, $rootScope, $timeout, $stateParams,
                                                             appTypeConfigurationModel, coreConstant, coreMediator,
                                                             dateUtil, proposalMediator, submissionConstant,
                                                             currencyUtil) {

    $scope.i18n = locale;

    $scope.viewModel = {
        shortDateFormat: coreMediator.getPreferenceByName('view.shortDateFormat'),
        isLoading: true,
        proposalSummaries: [],
        isUnderwriter: appTypeConfigurationModel.isUnderwriterWorkstation()
    };

    function loadProposalSummaries() {
        let submissionId = $stateParams.submissionId;

        $scope.viewModel.isLoading = true;

        proposalMediator.getProposalList(submissionId).then(function (proposalSummaries) {
            $scope.viewModel.proposalSummaries = filterProposalSummaries(proposalSummaries);
            $scope.viewModel.isLoading = false;
        });
    }

    function filterProposalSummaries(proposalSummaries) {
        return _.map(_.filter(proposalSummaries, function (proposalSummary) {
            return proposalSummary.quoteSummaries.length > 0;
        }), function (proposalSummary) {
            if(!_.isNil(proposalSummary.totalPremium)){
                proposalSummary.totalPremium.currencyFormat = currencyUtil.getCurrencyFormat(proposalSummary.totalPremium.currencyCode);
            }
            proposalSummary.isOpen = true;
            _.map(proposalSummary.quoteSummaries, function (quote) {
                quote.totalPremium.currencyFormat = currencyUtil.getCurrencyFormat(quote.totalPremium.currencyCode);
                return quote;
            });

            return proposalSummary;
        });
    }

    $scope.getProposalDescription = function (proposalSummary) {
        let description = proposalSummary.description;

        if (proposalSummary.quoteSummaries.length > 0) {
            description += ' (';
            _.each(proposalSummary.quoteSummaries, function (quoteSummary, index) {
                if (index > 0) {
                    description += ', ';
                }
                description += quoteSummary.productShortName;
                quoteSummary.totalPremium.currencyFormat = currencyUtil.getCurrencyFormat(quoteSummary.totalPremium.currencyCode);
            });
            description += ')';
        }
        return description;
    };

    $scope.openItem = function (item) {
        $rootScope.$broadcast(submissionConstant.event.OPEN_OWNER_URI, item.objectUri);
    };

    $scope.toggleDrawer = function (proposalSummary) {
        proposalSummary.isOpen = !proposalSummary.isOpen;
    };

    $scope.$on(coreConstant.event.REFRESH_PROPOSAL, function (event, proposalSummary, submissionId) {
        let index = _.indexOf($scope.viewModel.proposalSummaries, _.find($scope.viewModel.proposalSummaries, {id: proposalSummary.id})),
            oldProposalSummary = _.find($scope.viewModel.proposalSummaries, {id: proposalSummary.id});
        proposalSummary.isOpen = oldProposalSummary ? oldProposalSummary.isOpen : true;
        $timeout(function () {
            if (index >= 0) {
                $scope.viewModel.proposalSummaries.splice(index, 1, proposalSummary);
            }
            else if (submissionId === parseInt($stateParams.submissionId)) {
                $scope.viewModel.proposalSummaries.push(proposalSummary);
            }
        }, 0);
        $scope.viewModel.proposalSummaries = filterProposalSummaries($scope.viewModel.proposalSummaries);
    });

    $scope.$on(coreConstant.event.PROPOSAL_DELETED, function (event, proposalSummary) {
        $timeout(function () {
            _.remove($scope.viewModel.proposalSummaries, {id: proposalSummary.id});
        }, 0);
    });

    loadProposalSummaries();
};

angular.module('gw-um-submission')
    .controller('proposalSummariesController', ProposalSummariesController);
